const DEFAULT_COUNTRY = 'GB';

export const getCountry = (uiSchema) => (uiSchema['ui:widget'] && uiSchema['ui:widget'].country) || DEFAULT_COUNTRY;

export const getCorrectCountry = (country) => country === 'JA' ? 'JP' : country;